import { hostImg } from "../../../callApi/AxiosCall";
import { getProductApi, getProductDetailApi } from "../../../callApi/productApi";
import CustomBottom from "../../../components/CustomBottom";
import CustomButton from "../../../components/CustomButton";
import CustomHeader from "../../../components/CustomHeader";
import CustomInput from "../../../components/CustomInput";
import CustomPagination from "../../../components/CustomPagination";
import { Icon } from "@iconify/react";
import html2canvas from "html2canvas";
import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { format, isDate } from "date-fns";
import { th } from 'date-fns/locale/th'
import { useNavigate, useParams } from "react-router-dom";

export default function CircularDesignID() {
  const [productItem, setproductItem] = useState(null);
  const router = useNavigate();
  const params = useParams();
  const PrintRef = useRef();
  const PrintVerrifyRef = useRef();
  const [circularCheck, setcircularCheck] = useState(0);

  useEffect(() => {
    if (params.id != null) {
      callproduct();
    }
  }, [params]);

  const callproduct = async () => {
    let res = await getProductDetailApi({ product_id: params.id });
    if (res?.status == 200) {
      setproductItem(res.data.data);
      let tempcheck = 0;
      if (productItem?.circular_design?.ph_check) tempcheck += 1;
      if (productItem?.circular_design?.size_change_check) tempcheck += 1;
      if (productItem?.circular_design?.wash_durability_check) tempcheck += 1;
      if (productItem?.circular_design?.sweat_durability_check) tempcheck += 1;
      setcircularCheck(tempcheck);
    }
  };
  const QRData = () => {
    return (
      <div className="absolute -z-50 opacity-0">
        <div
          ref={PrintRef}
          className="w-[300px] h-[300px] p-3 flex flex-col items-center text-xl bg-white "
        >
          <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={
              "https://ftcdc-udru-qqp4p.ondigitalocean.app" +
              "/circular-design/" +
              params?.id
            }
            viewBox={`0 0 256 256`}
          />
          {/* {window.location.hostname+'/circular-design/'+ params?.id} */}
          <p className="font-medium ">{productItem?.no ?? ""}</p>
          <p className="font-bold ">{productItem?.name}</p>
        </div>
      </div>
    );
  };
  const VerrifyData = () => {
    return (
      <div className="hidden">
        <div
          ref={PrintVerrifyRef}
          className="w-[210mm] h-[297mm] text-xl p-0 flex flex-col items-center  bg-white text-black relative font_THSarabunNew"
        >
          <img src="/img/temp.jpg" className="w-full object-contain" />

          {/* {window.location.hostname+'/circular-design/'+ params?.id} */}
          <p className="font-bold  absolute left-[41mm] top-[34mm]">
            {productItem?.circular_design?.name ?? ""}
          </p>
          <p className="font-bold  absolute left-[134mm] top-[34mm]">
            {productItem?.circular_design?.phone ?? ""}
          </p>
          <p className="font-bold text-[17px] absolute left-[62mm] top-[39.7mm]">
            {productItem?.circular_design?.establishment ?? ""}
          </p>
          <p className="font-bold absolute left-[141mm] top-[39.5mm]">
            {productItem?.circular_design?.province ?? ""}
          </p>
          <p className="font-bold absolute left-[45mm] top-[45mm]">
            {productItem?.name ?? ""}
          </p>
          <p className="font-bold  absolute top-[50mm] left-[52mm]">
            {productItem?.product_types?.name ?? ""}
          </p>
          <p className="font-bold  absolute top-[50mm] left-[110mm]">
            {productItem?.no ?? ""}
          </p>
          <p className="font-bold  absolute top-[110.5mm] left-[62mm]">
            {productItem?.circular_design?.fiber_type ?? ""}
          </p>
          {productItem?.circular_design?.economy_label ==
          "ฉลากเศรษฐกิจหมุนเวียนสีเขียว (GREEN)" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[88.5mm] left-[39mm]"
            />
          ) : null}
          {productItem?.circular_design?.economy_label ==
          "ฉลากเศรษฐกิจหมุนเวียนสีทอง (GOLD)" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[94.5mm] left-[39mm]"
            />
          ) : null}
          {productItem?.circular_design?.economy_label ==
          "ฉลากเศรษฐกิจหมุนเวียนสีโรสโกลด์ (ROSE GOLD)" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[100.5mm] left-[39mm]"
            />
          ) : // <div className=" bg-black w-2 h-2 p-1 " />
          null}
          {productItem?.circular_design?.generalization != "" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[129mm] left-[39mm]"
            />
          ) : null}

          <p className="font-bold  absolute top-[134.5mm] left-[62mm]">
            {productItem?.circular_design?.generalization ?? ""}
          </p>
          {productItem?.circular_design?.ph_check ||
          productItem?.circular_design?.size_change_check ||
          productItem?.circular_design?.wash_durability_check ||
          productItem?.circular_design?.sweat_durability_check ? (
            <Icon
              icon="uil:check"
              className="absolute top-[140.5mm] left-[39mm]"
            />
          ) : null}

          {productItem?.circular_design?.ph_check ? (
            <Icon
              icon="uil:check"
              className="absolute top-[147.5mm] left-[51.5mm]"
            />
          ) : null}
          {productItem?.circular_design?.size_change_check ? (
            <Icon
              icon="uil:check"
              className="absolute top-[154.3mm] left-[51.5mm]"
            />
          ) : null}
          {productItem?.circular_design?.wash_durability_check ? (
            <Icon
              icon="uil:check"
              className="absolute top-[161mm] left-[51.5mm]"
            />
          ) : null}
          {productItem?.circular_design?.sweat_durability_check ? (
            <Icon
              icon="uil:check"
              className="absolute top-[167.5mm] left-[51.5mm]"
            />
          ) : null}
          {productItem?.circular_design?.certification_doc != "" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[174mm] left-[39mm]"
            />
          ) : null}
          {productItem?.circular_design?.certification_doc != "" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[181mm] left-[51.5mm]"
            />
          ) : null}
          <p className="font-bold  absolute top-[180.5mm] left-[88mm]">
            {productItem?.circular_design?.certification_doc ?? ""}
          </p>
          {circularCheck >= 3 ? (
            <Icon
              icon="uil:check"
              className="absolute top-[196.5mm] left-[66.5mm]"
            />
          ) : (
            <Icon
              icon="uil:check"
              className="absolute top-[196.5mm] left-[117.5mm]"
            />
          )}
          <p className="font-bold  absolute top-[205.5mm] left-[95mm]">
            {productItem?.circular_design?.production_steps ?? ""}
          </p>
          <p className="font-bold  absolute top-[211.5mm] left-[95mm]">
            {productItem?.circular_design?.processing_steps ?? ""}
          </p>
          {productItem?.circular_design?.tag_check != "" ? (
            <Icon
              icon="uil:check"
              className="absolute top-[228.5mm] left-[39mm]"
            />
          ) : null}
        </div>
      </div>
    );
  };

  const VerrifyDataNew = () => {
    <div>
      <div
        ref={PrintVerrifyRef}
        className="w-[210mm] h-[297mm] text-xl p-0 flex flex-col items-center  bg-white text-black relative font_THSarabunNew"
      >
        <img src="/img/67-1.png" className="w-full object-contain" />

        {/* {window.location.hostname+'/circular-design/'+ params?.id} */}
        <p className="font-bold  absolute left-[25mm] top-[43mm]">
          {productItem?.circular_design?.name ?? ""}
        </p>
        <p className="font-bold  absolute left-[134mm] top-[43mm]">
          {productItem?.circular_design?.phone ?? ""}
        </p>
        <p className="font-bold text-[17px] absolute left-[44.5mm] top-[49.5mm]">
          {productItem?.circular_design?.establishment ?? ""}
        </p>
        <p className="font-bold absolute left-[125mm] top-[49.5mm]">
          {productItem?.circular_design?.province ?? ""}
        </p>
        <p className="font-bold absolute left-[27mm] top-[55.5mm]">
          {productItem?.name ?? ""}
        </p>
        <p className="font-bold  absolute top-[61.5mm] left-[33mm]">
          {productItem?.product_types?.name ?? ""}
        </p>
        <p className="font-bold  absolute top-[61.5mm] left-[115mm]">
          {productItem?.no ?? ""}
        </p>
        <p className="font-bold  absolute top-[110.5mm] left-[62mm]">
          {productItem?.circular_design?.fiber_type ?? ""}
        </p>
        {productItem?.circular_design?.economy_label ==
        "ฉลากเศรษฐกิจหมุนเวียนสีเขียว (GREEN)" ? (
          <Icon
            icon="uil:check"
            className="absolute top-[88.5mm] left-[39mm]"
          />
        ) : null}
        {productItem?.circular_design?.economy_label ==
        "ฉลากเศรษฐกิจหมุนเวียนสีทอง (GOLD)" ? (
          <Icon
            icon="uil:check"
            className="absolute top-[94.5mm] left-[39mm]"
          />
        ) : null}
        {productItem?.circular_design?.economy_label ==
        "ฉลากเศรษฐกิจหมุนเวียนสีโรสโกลด์ (ROSE GOLD)" ? (
          <Icon
            icon="uil:check"
            className="absolute top-[100.5mm] left-[39mm]"
          />
        ) : // <div className=" bg-black w-2 h-2 p-1 " />
        null}
        {productItem?.circular_design?.generalization != "" ? (
          <Icon icon="uil:check" className="absolute top-[129mm] left-[39mm]" />
        ) : null}

        <p className="font-bold  absolute top-[134.5mm] left-[62mm]">
          {productItem?.circular_design?.generalization ?? ""}
        </p>
        {productItem?.circular_design?.ph_check ||
        productItem?.circular_design?.size_change_check ||
        productItem?.circular_design?.wash_durability_check ||
        productItem?.circular_design?.sweat_durability_check ? (
          <Icon
            icon="uil:check"
            className="absolute top-[140.5mm] left-[39mm]"
          />
        ) : null}

        {productItem?.circular_design?.ph_check ? (
          <Icon
            icon="uil:check"
            className="absolute top-[147.5mm] left-[51.5mm]"
          />
        ) : null}
        {productItem?.circular_design?.size_change_check ? (
          <Icon
            icon="uil:check"
            className="absolute top-[154.3mm] left-[51.5mm]"
          />
        ) : null}
        {productItem?.circular_design?.wash_durability_check ? (
          <Icon
            icon="uil:check"
            className="absolute top-[161mm] left-[51.5mm]"
          />
        ) : null}
        {productItem?.circular_design?.sweat_durability_check ? (
          <Icon
            icon="uil:check"
            className="absolute top-[167.5mm] left-[51.5mm]"
          />
        ) : null}
        {productItem?.circular_design?.certification_doc != "" ? (
          <Icon icon="uil:check" className="absolute top-[174mm] left-[39mm]" />
        ) : null}
        {productItem?.circular_design?.certification_doc != "" ? (
          <Icon
            icon="uil:check"
            className="absolute top-[181mm] left-[51.5mm]"
          />
        ) : null}
        <p className="font-bold  absolute top-[180.5mm] left-[88mm]">
          {productItem?.circular_design?.certification_doc ?? ""}
        </p>
        {circularCheck >= 3 ? (
          <Icon
            icon="uil:check"
            className="absolute top-[196.5mm] left-[66.5mm]"
          />
        ) : (
          <Icon
            icon="uil:check"
            className="absolute top-[196.5mm] left-[117.5mm]"
          />
        )}
        <p className="font-bold  absolute top-[255mm] left-[95mm]">
          {productItem?.circular_design?.production_steps ?? ""}
        </p>
        <p className="font-bold  absolute top-[261mm] left-[95mm]">
          {productItem?.circular_design?.processing_steps ?? ""}
        </p>
        {productItem?.circular_design?.tag_check != "" ? (
          <Icon
            icon="uil:check"
            className="absolute top-[228.5mm] left-[39mm]"
          />
        ) : null}
      </div>
    </div>;
  };
  const handleDownloadImage = async () => {
    // const element = document.getElementById('printQR')
    const canvas = await html2canvas(PrintRef.current, {
      allowTaint: true,
      useCORS: true,
      backgroundColor: "white",
      removeContainer: true,
    });
    const data = canvas.toDataURL("image/jpeg");
    const link = document.createElement("a");
    link.href = data;
    link.download = productItem?.name + "-qr-image.jpg";
    // document.body.appendChild(link);
    link.click();
    link.remove();
    // document.body.removeChild(link);
  };
  return (
    <div className="fade_In">
      <CustomHeader />

      <div className="flex flex-row items-center gap-4  pt-[180px]">
        <div className="  absolute left-[10vw]">
          <p className="font-medium text-[20px] text-[#B36427]">
            ผลิตภัณท์ท้องถิ่น
          </p>
          <p className="font-bold text-[32px] md:text-[64px]">CIRCULAR DESIGN</p>
        </div>
        <img src="/img/bgGreen.png" className="w-full object-contain" />
      </div>
      <div className="px-[10vw] py-[24px] flex flex-col items-center ">
        <div
          onClick={() => {
            router(-1);
          }}
          className="flex  items-center gap-4 w-full hover:cursor-pointer"
        >
          <img
            src={"/img/arrowLeft3.png"}
            className="w-[40px] h-[40px] object-contain drop-shadow-md"
          />
          <p className=" text-[36px] font-bold text-[#B36427]">
            {productItem?.name}
          </p>
        </div>
        <div className="flex flex-col md:flex-row  gap-10 mt-5 mb-5 w-full">
          <div className="flex-1 flex flex-col items-center">
            <Zoom>
              <img
                src={
                  productItem?.product_img
                    ? hostImg + productItem?.product_img
                    : ""
                }
                className="h-60 object-contain rounded-lg  drop-shadow-md "
              />
            </Zoom>
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">รหัสผลิตภัณฑ์ :</p>
              <p className="font-medium ">{productItem?.no ?? ""}</p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">ชื่อผลิตภัณฑ์ :</p>
              <p className="font-medium ">{productItem?.name}</p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">ประเภทฉลาก :</p>
              <p className="font-medium ">
                {productItem?.circular_design?.economy_label ?? ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">ประเภทผลิตภัณฑ์ :</p>
              <p className="font-medium ">
                {productItem?.product_types?.name ?? ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">คุณลักษณะ :</p>
              <p className="font-medium ">
                {productItem?.circular_design?.generalization ?? "-"}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">
                ชื่อสถานประกอบการ / กลุ่ม :
              </p>
              <p className="font-medium ">
                {productItem?.circular_design?.establishment ?? ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">จังหวัด :</p>
              <p className="font-medium ">
                {productItem?.circular_design?.province ?? ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">ชื่อผู้ยื่นขอ :</p>
              <p className="font-medium ">
                {productItem?.circular_design?.name ?? ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">เบอร์โทรศัพท์ :</p>
              <p className="font-medium ">
                {productItem?.circular_design?.phone ?? ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">
                วันที่รับรองผลิตภัณฑ์ :
              </p>
              <p className="font-medium ">
                {productItem?.circular_design?.cer_date
                  ? isDate(new Date(productItem?.circular_design?.cer_date))
                    ? format(
                        new Date(productItem?.circular_design?.cer_date),
                        "dd MMMM yyy",
                        {locale:th}
                      )
                    : ""
                  : ""}
              </p>
            </div>
            <div className="flex flex-row gap-4  text-lg">
              <p className="font-bold text-[#B36427]">วันที่ฉลากหมดอายุ :</p>
              <p className="font-medium ">
                {productItem?.circular_design?.exp_date
                  ? isDate(new Date(productItem?.circular_design?.exp_date))
                    ? format(
                        new Date(productItem?.circular_design?.exp_date),
                        "dd MMMM yyy",
                        {locale:th}
                      )
                    : ""
                  : ""}
              </p>
            </div>
            {/* <div className="flex flex-row gap-4  text-[24px]">
              <p className="font-bold text-[#B36427]">อายุ :</p>
              <p className="font-medium ">{productItem?.old ?? ""}</p>
            </div> */}
            {/* <div className="flex flex-row gap-4  text-[24px]">
              <p className="font-bold text-[#B36427]">เทคนิคการทอ :</p>
              <p className="font-medium ">{productItem?.technic ?? ""}</p>
            </div>
            <div className="flex flex-row gap-4  text-[24px]">
              <p className="font-bold text-[#B36427]">ลาย :</p>
              <p className="font-medium ">{productItem?.pattern ?? ""}</p>
            </div>
            <div className="flex flex-row gap-4  text-[24px]">
              <p className="font-bold text-[#B36427]">วัสดุ :</p>
              <p className="font-medium ">{productItem?.material ?? ""}</p>
            </div> */}
            <CustomButton
              txt={"QR Code"}
              classAdditional=" text-center font-semibold "
              bgcolor="#2E2E2E"
              onClick={() => {
                handleDownloadImage();
              }}
            />
            {productItem?.circular_design ? (
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return (
                    // <a>
                    //   QR Code
                    // </a>
                    <CustomButton
                      txt={
                        "ดาวน์โหลดสรุปผลการประเมินฉลากผลิตภัณฑ์ Circular Design"
                      }
                      classAdditional=" text-center font-semibold mt-2"
                    />
                  );
                }}
                content={() => PrintVerrifyRef.current}
              />
            ) : null}
          </div>
          {/* {productItem?.map((item, i) => {
          return (
            <div onClick={()=>{
              router.push('/circular-design/'+item.id)
            }} key={i} className="flex flex-col  items-center  font-medium text-xl cursor-pointer  active:opacity-50 hover:opacity-80 ">
              <img
                src={item.product_img?hostImg+item.product_img:''}
                className="w-full h-full object-cover rounded-lg  drop-shadow-md max-h-[400px]"
              />
              <p className="mt-3">{item.no??''}</p>
              <p>{item.name}</p>
            </div>
          );
        })} */}
        </div>
        <QRData />
        <VerrifyData />
      </div>
      <CustomBottom />
    </div>
  );
}
